import { AlertTriangle, Info, CheckCircle, XCircle } from 'lucide-react'

import type { NotificationType } from '@hooks/useNotifications'

export const HOVER_READ_DELAY_MS = 500

export const iconMap: Record<NotificationType, typeof Info> = {
  error: XCircle,
  warning: AlertTriangle,
  info: Info,
  success: CheckCircle,
}

export const typeStyles: Record<NotificationType, { text: string; bg: string; hoverBg: string; tint: string }> = {
  error: {
    text: 'text-destructive-foreground',
    bg: 'bg-destructive-foreground',
    hoverBg: 'hover:bg-destructive-foreground/20',
    tint: 'bg-destructive-foreground/5',
  },
  warning: {
    text: 'text-warning',
    bg: 'bg-warning',
    hoverBg: 'hover:bg-warning/20',
    tint: 'bg-warning/5',
  },
  info: {
    text: 'text-primary',
    bg: 'bg-primary',
    hoverBg: 'hover:bg-primary/20',
    tint: 'bg-primary/5',
  },
  success: {
    text: 'text-success',
    bg: 'bg-success',
    hoverBg: 'hover:bg-success/20',
    tint: 'bg-success/5',
  },
}

type CounterPriority = 'error' | 'warning' | 'default'

export const counterStyles: Record<CounterPriority, { bg: string; text: string }> = {
  error: { bg: 'bg-destructive-foreground', text: 'text-white' },
  warning: { bg: 'bg-warning', text: 'text-black' },
  default: { bg: 'bg-primary', text: 'text-white' },
}

export type { CounterPriority }
